export const removerTagsHtml = (str) => {
    console.log(str)
    console.log("removerTagsHtml")
    return str.replace(/<\/?[^>]+(>|$)/g, "");
}